import styled from "styled-components";

const StyledDocumentSelector = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`;

export default StyledDocumentSelector;
